module.exports = __webpack_public_path__ + "img/1566002933.81ea0597.jpg";